import searchAppReducer, { getAdminTabName, getApplicationName } from "./searchAppReducer";
import {applicationPrimaryVersion} from "./searchAppReducer";
import searchRegionReducer from "./searchRegionReducer";
import searchReducer from "./searchReducer";
import searchTermReducer from "./searchTermReducer";
import performSearchReducer from "./performSearchReducer";
import notificationReducer from "./notificationReducer";
import performSyncReducer,{performSyncValue} from "./performSyncReducer";
import syncTimerReducer from "./syncTimerReducer";
import { addDeleteVersionGroupsReducer } from "./addDeleteVersionGroupsReducer";
import adminTabReducer from "./adminTabReducer";
import searchTermLoadingVersions from "./searchTermLoadingVersions";
import appChoices from './appChoices';
import { deleteAllTabReducer } from './deleteAllTabReducer';
import { addUpgradeEnvironmentsReducer } from './upgradeEnvironmentsReducer';

export default {
  application: searchAppReducer,
  region: searchRegionReducer,
  searchBy: searchReducer,
  searchTerm: searchTermReducer,
  searchResults: performSearchReducer,
  notification: notificationReducer,
  biitInstances: performSyncReducer,
  performSyncValue: performSyncValue,
  updatedTimestamp: syncTimerReducer,
  applicationPrimary: applicationPrimaryVersion,
  getApplicationName: getApplicationName,
  addDeleteVersionGroups: addDeleteVersionGroupsReducer,
  getAdminTabName: getAdminTabName,
  adminTab: adminTabReducer,
  searchingVersions: searchTermLoadingVersions,
  appChoices: appChoices,
  deleteVersions: deleteAllTabReducer,
  upgradeEnvironments: addUpgradeEnvironmentsReducer,
};
